export default "/images/974a5d2a0fbc5e5b95368eb70265f675.avif";